export default __webpack_public_path__ + "static/media/indexx-logo-v3-light.5745d493.svg";